export default __webpack_public_path__ + "1.18.20/static/media/no-practices.8a6fd274.svg";